import NoResultsVehicleGrid from './NoResultsVehicleGrid';

export default NoResultsVehicleGrid;
